module.exports = __webpack_public_path__ + "img/logo.eaed282c.png";